import { Box, Container, Typography } from "@mui/material";
import AccordionComp from "../components/AccordionComp/AccordionComp";

export default function Experience() {
  return (
    <Box sx={{ py: { xs: 6, md: 10 } }}>
      <Container maxWidth="lg">
        <Box sx={{ mb: 5, textAlign: 'center' }}>
          <Typography
            variant="h3"
            component="h2"
            sx={{
              mb: 1,
              fontWeight: 'bold',
              background: 'linear-gradient(45deg, #72efdd, #7E4DE2)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Professional Experience
          </Typography>
        </Box>
        <AccordionComp />
      </Container>
    </Box>
  );
}
